import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, Util} from '../../../app/util';


@Component({
    selector: 'page-retirar-menu',
    templateUrl: 'retirar-menu.html',
    providers: []
})
export class RetirarMenuPage {

    config: any;

    etapa: number;

    akkjson = (window as any).handappMainInstance.appjson;
    warwriter: any;

    page00 = {title: 'Takeway', texto: 'Seu pedido está pronto!', warwriter: null, warning: 'O <b>' + 'Moscou' + '</b> disse que seu pedido está pronto.', werning: null};
    page01 = {title: 'Takeout', texto: 'Pedido em andamento', warwriter: null, warning: 'Apresente o número para o <b>' + 'Gabriel Bittencourt' + '</b> em <b>' + 'Moscou' + '</b>', werning: null};


    constructor(public navCtrl: NavController, public navParams: NavParams,
                public viewCtrl: ViewController, public util: Util) {


        this.config = CONFIG;

        this.etapa = this.navParams.get('etapa');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Produto Walk', '/produto-walk');

        this.wallkerLoad();

    }

    ionViewWillEnter() {

        setTimeout(() => {

            if (this.page00.warwriter) this.page00.warwriter.startLoader();
            if (this.page01.warwriter) this.page01.warwriter.startLoader();
            //if (this.warwriter) this.warwriter.startLoader();

        }, 700);

    }

    getTitle() {

        if (this.etapa == 0) return 'Takeway';
        if (this.etapa == 1) return 'Takeout';

    }

    wallkerLoad() {


    }

    dismiss() {

        this.viewCtrl.dismiss();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/retirar-menu/retirar-menu.ts